import { MODULE_NAME } from '@/Modules/ReportsModule/FinanceApplicationReport/shared/config/finance-applications-reports-module.config';

export function getModuleName(): string {
  return MODULE_NAME;
}
